import Vue from 'vue'
import VueRouter from 'vue-router'

import HomeBase from '../views/HomeBase'
import Home from '../views/Home'

import LiveSport from '../views/LiveSport'

import Tournament from '../views/Tournament'

import Match from '../views/Match'

import Team from '../views/Team'

import News from '../views/News.vue'
import NewsItem from '../views/NewsItem'

import Articles from '../views/Articles'
import Article from '../views/Article'

import Videos from '../views/Videos'
import Video from '../views/Video'

import Games from '../views/Games'


import Subscribe from "../views/Subscribe";
import NoMoney from "../views/NoMoney";


Vue.use(VueRouter);

const routes = [
	// Live
	{path: '/live', redirect: { name: 'live-sport', params: {sport: 'soccer'} }},
	{path: '/stat/:sport', name: 'live-sport', component: LiveSport},
	
	// Tournament
	{path: '/tournament/:id', name: 'tournament', component: Tournament},
	
	// Match
	{path: '/event/:id', name: 'event', component: Match},
	
	// Team
	{path: '/team/:id', name: 'team', component: Team},
	
	// News
	{path: '/news', name: 'news', component: News},
	{path: '/news/:id', name: 'news-item', component: NewsItem},
	
	// Articles
	{path: '/articles', name: 'articles', component: Articles},
	{path: '/articles/:id', name: 'article', component: Article},
	
	// Videos
	{path: '/videos', name: 'videos', component: Videos},
	{path: '/videos/:id', name: 'video', component: Video},
	
	// Games
	{path: '/games', name: 'games', component: Games},
	
	// Subscribe
	{ path: '/subscribe', name: 'subscribe', component: Subscribe },
	{ path: '/no-money', name: 'no-money', component: NoMoney },
	
	// Home
	{path: '/:sport', name: 'home', component: Home},
	{path: '/', name: 'home-base', component: HomeBase},
];

const router = new VueRouter({
	routes,
	mode: 'history',
	scrollBehavior(to, from, savedPosition) {
		window.events.$emit('page-changed');
		
		$('html, body').animate({
			scrollTop: 0
		}, 400);
	}
});

router.beforeEach((to, from, next) => {
	if (Vue.config.local) {
		next(); return;
	}
	
	if (to.name === 'home-base') {
		next(); return;
	}
	
	next(); return;
});

export default router
